// Some shared styles used by nav bar buttons.
// TODO: Update to use design system v2.

import styled from 'astroturf/react';
import _IconAnchor from "buttonStyles-IconAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/buttonStyles.ts?styleId=IconAnchor";
import _IconButton from "buttonStyles-IconButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/buttonStyles.ts?styleId=IconButton";
import _IconContainer from "buttonStyles-IconContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/buttonStyles.ts?styleId=IconContainer";
import _IconLabel from "buttonStyles-IconLabel.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/buttonStyles.ts?styleId=IconLabel";
import _NotificationDot from "buttonStyles-NotificationDot.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/buttonStyles.ts?styleId=NotificationDot";


export const IconAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "IconAnchor",
  styles: _IconAnchor
});

export const IconButton = /*#__PURE__*/styled("button", null, {
  displayName: "IconButton",
  styles: _IconButton
});

export const IconContainer = /*#__PURE__*/styled("div", null, {
  displayName: "IconContainer",
  styles: _IconContainer
});

export const IconLabel = /*#__PURE__*/styled("div", null, {
  displayName: "IconLabel",
  styles: _IconLabel
});

export const NotificationDot = /*#__PURE__*/styled("div", null, {
  displayName: "NotificationDot",
  styles: _NotificationDot
});
